import { ClinicianDTO } from "@/Common/Api/Labs/Dto/Responses/LabMessageGroupDTO";
import { SpanControl } from "@/Common/Components/SpanControl";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";

interface LabCliniciansCellProps {
    clinicians: ClinicianDTO[];
    isRed: boolean;
    isBold: boolean;
    cellClassName?: string;
}

function LabClinicianTableCell(props: Readonly<LabCliniciansCellProps>): JSX.Element {
    const { clinicians, isRed, isBold, cellClassName } = props;

    return (
        <div>
            {clinicians.map(clinician => {
                const clinicianName = [clinician?.Prefix, clinician?.Lastname, clinician?.Firstname].filter(p => p).join(" ");
                return (
                    <div title={clinicianName} key={`${clinicianName}-${GuidHelper.NewGuid()}`}>
                        <SpanControl
                            key={clinician?.ID_Number ?? ""}
                            IsRed={isRed}
                            IsBold={isBold}
                            className={cellClassName}
                            text={clinicianName}
                        />
                    </div>
                );
            })}
        </div>
    );
}

export { LabClinicianTableCell };
